import styled from 'styled-components'
import { Font16 } from 'components/Typography'
import { SubInfoBlock } from 'features/home/components/HomeStatus/SubInfo/styles'

export const LastHomeBackupContainer = styled(SubInfoBlock)`
  > div {
    gap: 30px;
  }
`

export const LastBackupBody = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  align-items: flex-start;
  font-weight: 700;
  ${Font16};
`
